import createReducer from 'src/utils/create-reducer';

import {
  DELETE_BRANCH_DIALOG,
  DELETE_BRANCH,
  DELETE_BRANCH_PAGE,
} from '../actions';

export type DeleteBranchErrorType =
  | 'ACCESS_DENIED'
  | 'BRANCH_NOT_FOUND'
  | 'GENERIC';

export const DeleteBranchErrorTypes = {
  ACCESS_DENIED: 'ACCESS_DENIED',
  BRANCH_NOT_FOUND: 'BRANCH_NOT_FOUND',
  GENERIC: 'GENERIC',
};

type DeleteBranchSuccessFlagState = {
  branchName: string | null | undefined;
};

type DeleteBranchErrorFlagState = {
  branchName: string | null | undefined;
  errorType: DeleteBranchErrorType | null | undefined;
};

export type DeleteBranchDialogState = {
  branchName: string;
  isOpen: boolean;
  isDeleting: boolean;
  successFlag: DeleteBranchSuccessFlagState;
  errorFlag: DeleteBranchErrorFlagState;
};

export const initialState: DeleteBranchDialogState = {
  branchName: '',
  isOpen: false,
  isDeleting: false,
  successFlag: {
    branchName: null,
  },
  errorFlag: {
    branchName: null,
    errorType: null,
  },
};

export default createReducer(initialState, {
  [DELETE_BRANCH_DIALOG.OPEN](state, action) {
    const { branchName } = action.payload;
    return {
      ...state,
      branchName,
      isOpen: true,
    };
  },
  [DELETE_BRANCH_DIALOG.CLOSE](state) {
    return {
      ...state,
      isOpen: false,
      branch: null,
    };
  },
  [DELETE_BRANCH.REQUEST](state) {
    return {
      ...state,
      isDeleting: true,
    };
  },
  [DELETE_BRANCH.SUCCESS](state, action) {
    const { branchName } = action.payload;
    return {
      ...state,
      isOpen: false,
      isDeleting: false,
      successFlag: {
        ...state.successFlag,
        branchName,
      },
    };
  },
  [DELETE_BRANCH.ERROR](state, action) {
    const { branchName, errorType } = action.payload;
    return {
      ...state,
      isOpen: false,
      isDeleting: false,
      errorFlag: {
        ...state.errorFlag,
        branchName,
        errorType,
      },
    };
  },
  [DELETE_BRANCH_PAGE.REQUEST](state) {
    return {
      ...state,
      isDeleting: true,
    };
  },
  [DELETE_BRANCH_PAGE.SUCCESS](state, action) {
    const { branchName } = action.payload;
    return {
      ...state,
      isOpen: false,
      isDeleting: false,
      successFlag: {
        ...state.successFlag,
        branchName,
      },
    };
  },
  [DELETE_BRANCH_PAGE.ERROR](state, action) {
    const { branchName, errorType } = action.payload;
    return {
      ...state,
      isOpen: false,
      isDeleting: false,
      errorFlag: {
        ...state.errorFlag,
        branchName,
        errorType,
      },
    };
  },
});
